import JsonEditor from './../JsonEditor';
import React, { useRef, useState, useEffect } from 'react';
import Spinner from '../Spinner';
import { Row, Col } from 'antd';
import ApiDocumentation from '../ApiDocsViewer/ApiDocsViewer';
import { useSearchParams, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateSelectionPathOpenApi } from '../../features/organization/organizationSlice';
import { useFileNavigationContext } from '../../contexts/FileNavigationContext';

function SwaggerView({ swaggerData, isEditable, setOpenApiFile }) {
  const editorRef = useRef('');
  const [isLoading, setIsLoading] = React.useState(true);
  const [key, setKey] = useState(0);
  const [searchParams] = useSearchParams();
  const params = useParams();
  const dispatch = useDispatch();
  const { setCurrentSelected, setExpandedKeys } = useFileNavigationContext();

  // Get API file ID from URL params
  const apiFileId = params.pageId || params.folderId;

  // Handle URL parameters to update Redux state and navigation context
  useEffect(() => {
    const method = searchParams.get('method');
    const path = searchParams.get('path');
    const tag = searchParams.get('tag');

    // Update organization slice with method and path
    if (method && path) {
      dispatch(updateSelectionPathOpenApi({ method, path }));

      // Update navigation context for sidebar highlighting
      if (apiFileId) {
        // Generate the method ID that would be used in the sidebar
        // Format: ${apiFileId}-${method}-${path}
        const methodId = `${apiFileId}-${method}-${path}`;
        setCurrentSelected(methodId);

        // Expand the main API file first
        setExpandedKeys((prevKeys) => {
          const newKeys = [...prevKeys];

          // Always expand the main API file
          if (!newKeys.includes(apiFileId)) {
            newKeys.push(apiFileId);
          }

          // If there's a tag, expand it in the sidebar
          if (tag) {
            const tagId = `tag-${apiFileId}-${tag}-openApi`;
            if (!newKeys.includes(tagId)) {
              newKeys.push(tagId);
            }
          }

          return newKeys;
        });
      }
    } else {
      // Clear selection if no method/path in URL
      dispatch(updateSelectionPathOpenApi({ method: null, path: null }));
    }
  }, [searchParams, dispatch, setCurrentSelected, setExpandedKeys, apiFileId]);

  React.useEffect(() => {
    if (swaggerData?.openapi === null) editorRef.current = '';
    if (swaggerData?.openapi) editorRef.current = JSON.stringify(swaggerData?.openapi, null, 2);
    setKey((prev) => prev + 1);
    setIsLoading(false);
  }, [swaggerData]);

  const handleJsonChange = (updatedJson) => {
    editorRef.current = updatedJson;
    setOpenApiFile(updatedJson);
  };

  return (
    <div>
      {isLoading && !swaggerData ? (
        <div className="spinner-wrapper">
          <Spinner />
        </div>
      ) : (
        <Row>
          <Col span={isEditable ? 12 : 24}>
            <ApiDocumentation key={key} spec={swaggerData?.openapi} />
          </Col>
          <Col span={isEditable ? 12 : 0}>
            <div className="json-editor-wrapper overflow-hidden">
              <div className="overflow-auto">
                <JsonEditor
                  jsonData={JSON.stringify(swaggerData?.openapi, null, 2)}
                  isEditable={isEditable}
                  setJsonData={handleJsonChange}
                />
              </div>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default SwaggerView;
